import { z } from "zod";

import { zSignatureInitialsRequired } from "@/utils/zod";

export const inputOutputFlowsheetFormSchema = z.object({
  inputOutputDate: z.date().nullable(),
  inputOutputTime: z.string().nullable(),
  inputOutputInput: z.string().optional(),
  inputOutputOutput: z.string().optional(),
  inputOutputNotes: z.string().optional(),
  signatureInitials: zSignatureInitialsRequired(),
});

export type InputOutputFlowsheetFormSchemaType = z.infer<typeof inputOutputFlowsheetFormSchema>;
